import UltMeta, { Meta } from "./UltMeta/index";

// 距离单位
class LengthUnit extends UltMeta {
    M = new Meta(1, "m");
    KM = new Meta(2, "km");
    NM = new Meta(3, "nm");
}
export const LENGTH_UNIT = new LengthUnit();
